import { ParameterRow } from './parameter-row-model';

export class ParameterRows {
    Rows: ParameterRow[] = [];
}
